
var id = "delete";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 240 240\" id=\"delete\">\n<style type=\"text/css\">\n\t#delete .st0{}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M120,20C64.77,20,20,64.77,20,120s44.77,100,100,100s100-44.77,100-100S175.23,20,120,20z M120,200\n\t\tc-44.18,0-80-35.82-80-80s35.82-80,80-80s80,35.82,80,80S164.18,200,120,200z\" />\n\t<path class=\"st0\" d=\"M155.45,84.31c-3.91-3.91-11.03-3.11-15.91,1.77l-19.45,19.45l-19.54-19.54c-4.88-4.88-12-5.67-15.91-1.77l0,0\n\t\tc-3.91,3.91-3.11,11.03,1.77,15.91l19.54,19.54l-19.45,19.45c-4.88,4.88-5.67,12-1.77,15.91c3.91,3.91,11.03,3.11,15.91-1.77\n\t\tl19.45-19.45l19.35,19.35c4.88,4.88,12,5.67,15.91,1.77l0,0c3.91-3.91,3.11-11.03-1.77-15.91l-19.35-19.35l19.45-19.45\n\t\tC158.56,95.34,159.36,88.22,155.45,84.31z\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
